import { useState } from 'react';
import React from 'react';

import '../scss/Elements/_tables.scss';
import { Helmet } from 'react-helmet';
import { useTranslationHook } from '../hooks/UseTranslationHook';
import { SitesTableAxios } from '../components/Tables/SitesTable';
import { ClientTiTable } from '../components/Tables/Sigma/ClientTiTable';
import { Tab, Tabs } from '@mui/material';

function Sites() {
  const { titleSitesString } = useTranslationHook();

  const [tabValue, setTabValue] = useState('1');

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className='table-module-container'>
      <Helmet>
        <title>{titleSitesString}</title>
      </Helmet>

      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        aria-label='bank tabs'
        sx={{
          pb: 2,
        }}
      >
        <Tab
          label='Sucursales'
          value='1'
          sx={{
            color: 'inherit',
            fontFamily: 'quicksand, sans-serif',
            fontWeight: 'bold',
            textTransform: 'none',
            fontSize: '1rem',
            '&.Mui-selected': { color: '#212529' },
            '&:not(.Mui-selected)': { color: '#757575' },
          }}
        />

        <Tab
          label='Contacto de Sucursal'
          value='2'
          sx={{
            color: 'inherit',
            fontFamily: 'quicksand, sans-serif',
            fontWeight: 'bold',
            textTransform: 'none',
            fontSize: '1rem',
            '&.Mui-selected': { color: '#212529' },
            '&:not(.Mui-selected)': { color: '#757575' },
          }}
        />
      </Tabs>

      {tabValue === '1' && <SitesTableAxios />}
      {tabValue === '2' && <ClientTiTable />}
    </div>
  );
}

export default Sites;
